import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_indicator_widget = _resolveComponent("indicator-widget")!
  const _component_WidgetBase = _resolveComponent("WidgetBase")!

  return (_openBlock(), _createBlock(_component_WidgetBase, {
    title: _ctx.$t('dashboard.temperature_widget.title'),
    widget: _ctx.widget,
    mode: _ctx.widgetMode,
    empty: !_ctx.currentStation,
    editable: _ctx.editable,
    padding: false,
    isHoverable: true,
    isActive: _ctx.active,
    onClick: _ctx.onWidgetClick,
    class: "is-clipped"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_indicator_widget, {
        description: _ctx.$t('dashboard.temperature_widget.description'),
        unit: _ctx.unit,
        value: _ctx.temperature,
        mask: _ctx.img
      }, null, 8 /* PROPS */, ["description", "unit", "value", "mask"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["title", "widget", "mode", "empty", "editable", "isActive", "onClick"]))
}